routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('search', {
      url: '/search',
      template: require('./index.html'),
      controller: 'SearchController',
      controllerAs: 'search',
      authRequired: true
    })
}



// WEBPACK FOOTER //
// ./src/app/features/search/routes.js